;(function() {
  'use strict'

  Controller.$inject = ["$sce", "$element", "$timeout", "portalLayoutService", "projectTrackerService"];
  angular.module('app.core').component('projectTrackerPreview', {
    controller: Controller,
    templateUrl: 'project-tracker-preview.html',
    bindings: {
      tracker: '=',
      onBack: '&',
    },
  })

  /* @ngInject */
  function Controller(
    $sce,
    $element,
    $timeout,
    portalLayoutService,
    projectTrackerService
  ) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$postLink = postLink
    ctrl.$onDestroy = onDestroy

    function onInit() {
      portalLayoutService.setBack(function() {
        ctrl.onBack()
      })
      portalLayoutService.hideFooter()

      // Spinner stays up from init until the iframe's own `load` event fires
      // (document + referenced subresources finished). We intentionally do NOT
      // clear it when the HTML fetch resolves below.
      ctrl.isLoading = true
      ctrl.hasError = false
      ctrl.loadProgress = null
      projectTrackerService
        .getFileHtml(ctrl.tracker.projectId, ctrl.tracker.id, {
          onDownloadProgress: setLoadProgress,
        })
        .then(function(html) {
          var blob = new Blob([html], { type: 'text/html' })
          ctrl.blobUrl = window.URL.createObjectURL(blob)
          // ng-src now writes the iframe src -> the browser loads the blob ->
          // onIframeLoad flips isLoading off once it has finished.
          ctrl.iframeSrc = $sce.trustAsResourceUrl(ctrl.blobUrl)
        })
        .catch(function(resp) {
          // Backend failed (auth/404/500/network): stop the spinner and show an
          // error instead of leaving the user staring at it forever.
          ctrl.isLoading = false
          ctrl.hasError = true
          ctrl.errorMessage =
            (resp && resp.data && resp.data.message) ||
            'We couldn’t load this tracker. Please try again.'
        })
    }

    // $postLink guarantees the templateUrl has been linked, so the iframe
    // element exists. The listener is attached once, before src is ever set.
    function postLink() {
      ctrl.iframeEl = $element[0].querySelector('#projectTrackerIframe')
      if (ctrl.iframeEl) ctrl.iframeEl.addEventListener('load', onIframeLoad)
    }

    function onIframeLoad() {
      // Native DOM event fires outside Angular's digest; $timeout schedules the
      // model change and triggers a digest so the spinner actually disappears.
      // Guard against the initial about:blank load before a src is set.
      if (!ctrl.iframeSrc) return
      $timeout(function() {
        ctrl.loadProgress = 100
        ctrl.isLoading = false
      })
    }

    function setLoadProgress(progress) {
      $timeout(function() {
        ctrl.loadProgress = progress
      })
    }

    function onDestroy() {
      portalLayoutService.clearBack()
      portalLayoutService.showFooter()

      if (ctrl.iframeEl) ctrl.iframeEl.removeEventListener('load', onIframeLoad)
      if (ctrl.blobUrl) window.URL.revokeObjectURL(ctrl.blobUrl)
    }
  }
})()
